// 9fbef606107a605d69c0edbcd8029e5d1
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  display: flex;
  @media ${(props) => props.theme.mediaQuery.large} {
    justify-content: left;
  }

  .brand-seperator {
    border-left: 1px ${(props) => props.theme.colors.WHITE} solid;
    margin: 10px 0;
  }
  a.brand-tab-tcp,
  a.brand-tab-gymboree,
  a.brand-tab-snj,
  a.brand-tab-pjp,
  button.brand-tab-tcp,
  button.brand-tab-gymboree,
  button.brand-tab-snj,
  button.brand-tab-pjp {
    height: 74px;
    width: 105px;
    display: flex;
    align-items: center;
    margin-right: 5px;
    padding: 0px 12px;

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-right: 10px;
      padding: 11px 12px;
      height: 34px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      flex: 1;
      padding: 8px 0px;
      margin-right: 0px;
    }
  }
  .header__brand-tab-gymboree {
    height: 36px;
    width: auto;
    margin: auto;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 27px;
    }
    svg {
      fill: #b984ff;
    }
  }

  ${(props) =>
    props.isStickyHeaderBgColorEnabled
      ? `
    // active tab
      a.brand-tab-tcp.header-topnav__brand-tabs--activeTab, button.brand-tab-tcp.header-topnav__brand-tabs--activeTab {
        img {
          display: none;
        }
        &:after {
          content: '';
          background: url('${getIconPath('header__brand-tab-tcp', props)}'); 
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          background-repeat: no-repeat;
        }
      }
      a.brand-tab-gymboree.header-topnav__brand-tabs--activeTab, button.brand-tab-gymboree.header-topnav__brand-tabs--activeTab {
        img {
          display: none;
        }
        &:after {
          content: '';
          background: url('${getIconPath('header__brand-tab-gymboree', props)}'); 
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          background-repeat: no-repeat;
        }
      }

    // non active tab
      a.brand-tab-tcp:not(.header-topnav__brand-tabs--activeTab), button.brand-tab-tcp:not(.header-topnav__brand-tabs--activeTab) {
        img {
          display: none;
        }
        &:after {
          content: '';
          background: url('${getIconPath('header__brand-tab--tcp-alt', props)}'); 
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          background-repeat: no-repeat;
          @media ${props.theme.mediaQuery.smallMax} {
            width: 44%;
          }
        }
      }
      a.brand-tab-gymboree:not(.header-topnav__brand-tabs--activeTab), button.brand-tab-gymboree:not(.header-topnav__brand-tabs--activeTab) {
        img {
          display: none;
        }
        &:after {
          content: '';
          background: url('${getIconPath('header__brand-tab-gymboree-alt', props)}');
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          background-repeat: no-repeat;
          @media ${props.theme.mediaQuery.smallMax} {
            width: 44%;
          }
        }
      }
    `
      : ``}

  .header__brand-tab--tcp {
    width: auto;
    height: 32px;
    margin: auto;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 24px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 28px;
    }
  }

  .header__brand-tab-snj {
    height: 36px;
    width: 83%;
    margin: auto;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 27px;
    }
  }

  .header__brand-tab-pjp {
    height: 14px;
    width: auto;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 18px;
    }
    margin: auto;
  }

  .brand-tab-snj:not(.header-topnav__brand-tabs--activeTab) {
    .header__brand-tab-snj {
      display: block !important;
    }
    &:after {
      display: none;
    }
  }
  .brand-tab-snj.header-topnav__brand-tabs--activeTab {
    background-color: ${(props) => props.theme.colors.WHITE};
    .header__brand-tab-snj {
      height: 42px;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        height: 34px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        height: 30px;
      }
    }
    &:after {
      content: '';
      height: 42px;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        height: 34px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        height: 30px;
      }
    }
  }

  .brand-tab-gymboree.header-topnav__brand-tabs--activeTab {
    background-color: ${(props) => props.theme.colorPalette.white};
    .header__brand-tab-gymboree {
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        height: 22px;
      }
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        height: 18px;
      }
    }
  }
  .brand-tab-tcp.header-topnav__brand-tabs--activeTab {
    background-color: ${(props) => props.theme.colorPalette.white};
  }
  .brand-tab-pjp.header-topnav__brand-tabs--activeTab {
    background-color: ${(props) => props.theme.colorPalette.white};
  }
  a,
  button {
    /* border-radius: 5px 5px 0px 0px; */
    display: inline-block;
    padding: 9px 15px;
    position: relative;

    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 8px 15px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 8px 20px;
    }
  }
  button:focus {
    background-color: transparent;
  }
  .header__brand-tab-active-button {
    padding: 0;
  }
`;
